(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beach-event-carousel"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=carousel=>{if(carousel.dataset.initialised==='true')return;const slides=Array.from(carousel.querySelectorAll('[data-beach-carousel-slide]'));if(!slides.length)return;carousel.dataset.initialised='true';carousel.dataset.slideCount=String(slides.length);const prev=carousel.querySelector('[data-beach-carousel-prev]'),next=carousel.querySelector('[data-beach-carousel-next]'),dotsWrap=carousel.querySelector('[data-beach-carousel-dots]'),autoplay=carousel.dataset.autoplay==='true'&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches,interval=Number(carousel.dataset.interval)||5000;let index=0,timer=null,pointerX=null,stopped=false;const dots=slides.map((slide,i)=>{const dot=document.createElement('button');dot.type='button';dot.className='beach-carousel__dot';dot.setAttribute('aria-label',`Show slide ${i+1}`);dot.addEventListener('click',()=>show(i,true));dotsWrap.appendChild(dot);return dot});const schedule=()=>{if(timer)window.clearTimeout(timer);timer=null;if(!autoplay||stopped||slides.length<2)return;const video=slides[index].querySelector('video');if(video){video.loop=false;video.addEventListener('ended',()=>show(index+1,false),{once:true})}else timer=window.setTimeout(()=>show(index+1,false),interval)};const updateVideos=()=>{slides.forEach((slide,i)=>{const video=slide.querySelector('video');if(!video)return;if(i===index){video.loop=!autoplay||stopped;video.play().catch(()=>{})}else{video.pause();video.muted=true;video.loop=false;try{video.currentTime=0}catch(error){}const sound=slide.querySelector('[data-beach-carousel-sound]');if(sound){sound.textContent='Unmute';sound.setAttribute('aria-pressed','false')}}})};function show(nextIndex,manual){if(manual)stopped=true;if(timer)window.clearTimeout(timer);index=(nextIndex+slides.length)%slides.length;slides.forEach((slide,i)=>{const active=i===index;slide.classList.toggle('is-active',active);slide.setAttribute('aria-hidden',String(!active))});dots.forEach((dot,i)=>{const active=i===index;dot.classList.toggle('is-active',active);dot.setAttribute('aria-current',active?'true':'false')});updateVideos();schedule()}carousel.querySelectorAll('[data-beach-carousel-sound]').forEach(button=>{const video=button.closest('[data-beach-carousel-slide]')?.querySelector('video');if(!video)return;button.addEventListener('click',()=>{stopped=true;video.muted=!video.muted;button.textContent=video.muted?'Unmute':'Mute';button.setAttribute('aria-pressed',String(!video.muted));if(!video.muted)video.play().catch(()=>{})})});prev?.addEventListener('click',()=>show(index-1,true));next?.addEventListener('click',()=>show(index+1,true));carousel.addEventListener('pointerdown',event=>{pointerX=event.clientX;stopped=true});carousel.addEventListener('pointerup',event=>{if(pointerX===null)return;const distance=event.clientX-pointerX;pointerX=null;if(Math.abs(distance)>=50)show(index+(distance<0?1:-1),true)});carousel.addEventListener('pointercancel',()=>{pointerX=null});const section=carousel.closest('.shopify-section');section?.addEventListener('shopify:block:select',event=>{const selected=event.target.closest('[data-beach-carousel-slide]');if(!selected)return;const selectedIndex=slides.indexOf(selected);if(selectedIndex>=0)show(selectedIndex,true)});show(0,false)};const initAll=()=>document.querySelectorAll('[data-beach-carousel]').forEach(init);document.addEventListener('DOMContentLoaded',initAll);document.addEventListener('shopify:section:load',initAll)})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["beach-event-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialise = () => {
    document.querySelectorAll('[data-beach-event]').forEach((section) => {
      const popupNamePrefix = 'beachEventWineClubLogin:';
      const loginLink = section.querySelector('[data-wc-login-link]');
      const loginErrorElement = section.querySelector('[data-login-error]');

      if (loginLink && section.dataset.loginInitialised !== 'true') {
        section.dataset.loginInitialised = 'true';

        const popupName = `${popupNamePrefix}${section.id || 'default'}`;
        let loginPopup = null;
        let popupWatcher = null;

        const stopWatchingPopup = () => {
          if (!popupWatcher) return;
          window.clearInterval(popupWatcher);
          popupWatcher = null;
        };

        const closePopupAndRefresh = () => {
          stopWatchingPopup();

          if (loginPopup && !loginPopup.closed) {
            loginPopup.close();
          }

          loginPopup = null;
          window.location.reload();
        };

        const checkLoginStatus = () => {
          if (!loginPopup) return;

          if (loginPopup.closed) {
            closePopupAndRefresh();
            return;
          }

          try {
            const popupLocation = new URL(loginPopup.location.href);
            const popupPath = popupLocation.pathname.replace(/\/+$/, '') || '/';

            if (
              popupLocation.origin === window.location.origin &&
              popupPath === '/account'
            ) {
              closePopupAndRefresh();
            }
          } catch (error) {
            // The popup may briefly be cross-origin during authentication. Keep checking.
          }
        };

        loginLink.addEventListener('click', (event) => {
          event.preventDefault();

          const popupWidth = 520;
          const popupHeight = Math.min(760, window.screen.availHeight - 80);
          const popupLeft = Math.max(
            0,
            Math.round((window.screen.availWidth - popupWidth) / 2)
          );
          const popupTop = Math.max(
            0,
            Math.round((window.screen.availHeight - popupHeight) / 2)
          );

          loginPopup = window.open(
            loginLink.href,
            popupName,
            `popup=yes,width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`
          );

          if (!loginPopup) {
            if (loginErrorElement) {
              loginErrorElement.textContent =
                'Please allow pop-ups to log in without leaving this page.';
              loginErrorElement.hidden = false;
            }
            return;
          }

          if (loginErrorElement) {
            loginErrorElement.textContent = '';
            loginErrorElement.hidden = true;
          }

          loginPopup.focus();
          stopWatchingPopup();
          popupWatcher = window.setInterval(checkLoginStatus, 250);
        });

        window.addEventListener('beforeunload', stopWatchingPopup);
      }

      if (section.dataset.bookingInitialised === 'true') return;
      section.dataset.bookingInitialised = 'true';

      const quantityInput = section.querySelector('[data-event-quantity]');
      const minusButton = section.querySelector('[data-event-minus]');
      const plusButton = section.querySelector('[data-event-plus]');
      const addButton = section.querySelector('[data-event-add]');
      const errorElement = section.querySelector('[data-event-error]');
      if (!quantityInput || !minusButton || !plusButton || !addButton || !errorElement) return;

      const productId = Number(section.dataset.productId);
      const clampQuantity = () => {
        const parsed = Number.parseInt(quantityInput.value, 10);
        quantityInput.value = String(Math.min(2, Math.max(1, Number.isFinite(parsed) ? parsed : 1)));
        minusButton.disabled = Number(quantityInput.value) <= 1;
        plusButton.disabled = Number(quantityInput.value) >= 2;
      };

      minusButton.addEventListener('click', () => {
        quantityInput.value = String(Number(quantityInput.value) - 1);
        clampQuantity();
      });
      plusButton.addEventListener('click', () => {
        quantityInput.value = String(Number(quantityInput.value) + 1);
        clampQuantity();
      });
      quantityInput.addEventListener('input', clampQuantity);
      quantityInput.addEventListener('change', clampQuantity);

      addButton.addEventListener('click', async () => {
        errorElement.hidden = true;
        errorElement.textContent = '';
        clampQuantity();

        const selectedVariant = section.querySelector('[data-event-variant]:checked');
        if (!selectedVariant) {
          errorElement.textContent = 'Please choose an available session.';
          errorElement.hidden = false;
          return;
        }

        const requestedQuantity = Number(quantityInput.value);
        const selectedVariantId = Number(selectedVariant.value);
        const originalButtonText = addButton.textContent;
        addButton.disabled = true;
        addButton.textContent = 'Checking cart...';

        try {
          const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`, {
            credentials: 'same-origin',
            headers: { 'Accept': 'application/json' }
          });
          const cart = await cartResponse.json();
          if (!cartResponse.ok) throw new Error('We could not check your cart. Please try again.');

          const eventLines = cart.items.filter((item) => Number(item.product_id) === productId);
          const existingQuantity = eventLines.reduce((total, item) => total + Number(item.quantity || 0), 0);
          const hasDifferentSlot = eventLines.some((item) => Number(item.variant_id) !== selectedVariantId);

          if (hasDifferentSlot) {
            throw new Error('Both tickets must be booked for the same session. Please remove your existing event ticket before selecting another time.');
          }
          if (existingQuantity + requestedQuantity > 2) {
            throw new Error('Maximum 2 tickets per member.');
          }

          addButton.textContent = 'Adding tickets...';
          const addResponse = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: selectedVariantId, quantity: requestedQuantity }] })
          });
          const result = await addResponse.json();
          if (!addResponse.ok) throw new Error(result.description || result.message || 'The tickets could not be added to your cart.');

          window.location.href = window.Shopify.routes.root + 'cart';
        } catch (error) {
          errorElement.textContent = error.message;
          errorElement.hidden = false;
          addButton.disabled = false;
          addButton.textContent = originalButtonText;
        }
      });

      clampQuantity();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise);
  } else {
    initialise();
  }
  document.addEventListener('shopify:section:load', initialise);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["event-ticket-cart-guard-section"]) return;
  try {
    
  (() => {
    const initialise = () => {
      const guard = document.querySelector('[data-event-cart-guard]');
      if (!guard || guard.dataset.initialised === 'true') return;
      guard.dataset.initialised = 'true';

      const eventProductId = Number(guard.dataset.productId);
      const message = guard.querySelector('[data-event-cart-message]');
      const staticBlocked =
        guard.dataset.alreadyClaimed === 'true' ||
        (guard.dataset.inviteOnly === 'true' && guard.dataset.loggedIn !== 'true') ||
        (guard.dataset.inviteOnly === 'true' && guard.dataset.isEligible !== 'true');

      const checkoutControls = () => Array.from(document.querySelectorAll('[name="checkout"], a[href="/checkout"], a[href$="/checkout"]'));
      const setCheckoutState = (invalid, text) => {
        guard.dataset.invalid = String(invalid);
        guard.classList.toggle('event-ticket-cart-guard--invalid', invalid);
        if (text) message.textContent = text;
        checkoutControls().forEach((control) => {
          if (invalid) {
            control.setAttribute('aria-disabled', 'true');
            control.setAttribute('disabled', 'disabled');
            control.style.pointerEvents = 'none';
            control.style.opacity = '0.5';
          } else {
            control.removeAttribute('aria-disabled');
            control.removeAttribute('disabled');
            control.style.pointerEvents = '';
            control.style.opacity = '';
          }
        });
      };

      const validateCart = async () => {
        if (staticBlocked) { setCheckoutState(true, message.textContent.trim()); return false; }
        const response = await fetch(`${window.Shopify.routes.root}cart.js`, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } });
        const cart = await response.json();
        if (!response.ok) { setCheckoutState(true, 'We could not verify your event tickets. Please refresh the cart and try again.'); return false; }

        const eventLines = cart.items.filter((item) => Number(item.product_id) === eventProductId);
        const totalQuantity = eventLines.reduce((total, item) => total + Number(item.quantity || 0), 0);
        const variantIds = new Set(eventLines.map((item) => Number(item.variant_id)));
        if (totalQuantity > 2) { setCheckoutState(true, 'Maximum 2 tickets per customer. Please reduce your event ticket quantity to continue.'); return false; }
        if (variantIds.size > 1) { setCheckoutState(true, 'Both tickets must be booked for the same session. Please remove one time slot to continue.'); return false; }
        setCheckoutState(false, 'Event ticket rules: maximum 2 tickets, both for the same session.');
        return true;
      };

      document.querySelectorAll(`[data-cart-line][data-product-id="${eventProductId}"] input[type="number"]`).forEach((input) => { input.max = '2'; });
      document.addEventListener('click', async (event) => {
        const checkout = event.target.closest('[name="checkout"], a[href="/checkout"], a[href$="/checkout"]');
        if (!checkout || checkout.dataset.eventGuardApproved === 'true') return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const valid = await validateCart();
        if (!valid) { guard.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        checkout.dataset.eventGuardApproved = 'true';
        if (checkout.tagName === 'A') window.location.href = checkout.href;
        else if (checkout.form) checkout.form.requestSubmit(checkout);
      }, true);
      validateCart();
    };

    document.addEventListener('DOMContentLoaded', initialise);
    document.addEventListener('shopify:section:load', initialise);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["events-grid"] && !Shopify.designMode) return;
  try {
    
  const sortEventCards = (root) => {
    root.querySelectorAll('[data-event-list]').forEach((list) => {
      const direction = list.dataset.eventList === 'past' ? -1 : 1;
      const cards = Array.from(list.querySelectorAll('[data-event-timestamp]'));

      cards
        .sort((firstCard, secondCard) => {
          const firstTimestamp = Number(firstCard.dataset.eventTimestamp);
          const secondTimestamp = Number(secondCard.dataset.eventTimestamp);
          return (firstTimestamp - secondTimestamp) * direction;
        })
        .forEach((card) => list.appendChild(card));
    });
  };

  const sortEventFilterButtons = (filterGroup) => {
    const buttonsContainer = filterGroup.querySelector('.events-grid__filters');
    const allButton = filterGroup.querySelector('[data-event-filter-value="all"]');
    const filterButtons = Array.from(
      filterGroup.querySelectorAll('[data-event-filter-value]:not([data-event-filter-value="all"])'),
    );

    if (!buttonsContainer) {
      return;
    }

    filterButtons
      .sort((firstButton, secondButton) => {
        if (filterGroup.dataset.eventFilterGroup === 'month') {
          return firstButton.dataset.eventFilterValue.localeCompare(secondButton.dataset.eventFilterValue);
        }

        return firstButton.textContent.trim().localeCompare(secondButton.textContent.trim());
      })
      .forEach((button) => buttonsContainer.appendChild(button));

    if (allButton) {
      buttonsContainer.prepend(allButton);
    }
  };

  const applyEventFilters = (root) => {
    const upcomingList = root.querySelector('[data-event-list="upcoming"]');

    if (!upcomingList) {
      return;
    }

    const selectedFilters = {};

    root.querySelectorAll('[data-event-filter-group]').forEach((filterGroup) => {
      const selectedButton = filterGroup.querySelector('[data-event-filter-value][aria-pressed="true"]');
      selectedFilters[filterGroup.dataset.eventFilterGroup] = selectedButton?.dataset.eventFilterValue || 'all';
    });

    let visibleCount = 0;

    upcomingList.querySelectorAll('[data-event-month][data-event-location]').forEach((card) => {
      const monthMatches =
        !selectedFilters.month || selectedFilters.month === 'all' || card.dataset.eventMonth === selectedFilters.month;
      const locationMatches =
        !selectedFilters.location ||
        selectedFilters.location === 'all' ||
        card.dataset.eventLocation === selectedFilters.location;
      const isVisible = monthMatches && locationMatches;

      card.hidden = !isVisible;

      if (isVisible) {
        visibleCount += 1;
      }
    });

    const emptyMessage = root.querySelector('[data-event-filter-empty]');

    if (emptyMessage) {
      emptyMessage.hidden = visibleCount > 0;
    }
  };

  const initialiseEventFilters = (root) => {
    const filters = root.querySelector('[data-event-filters]');

    if (!filters || filters.dataset.initialised === 'true') {
      return;
    }

    filters.querySelectorAll('[data-event-filter-group]').forEach(sortEventFilterButtons);

    filters.addEventListener('click', (event) => {
      const selectedButton = event.target.closest('[data-event-filter-value]');

      if (!selectedButton || !filters.contains(selectedButton)) {
        return;
      }

      const filterGroup = selectedButton.closest('[data-event-filter-group]');

      if (!filterGroup) {
        return;
      }

      filterGroup.querySelectorAll('[data-event-filter-value]').forEach((button) => {
        button.setAttribute('aria-pressed', button === selectedButton ? 'true' : 'false');
      });

      applyEventFilters(root);
    });

    filters.dataset.initialised = 'true';
    applyEventFilters(root);
  };

  const initialiseEventGrids = (scope = document) => {
    scope.querySelectorAll('[data-events-grid]').forEach((root) => {
      sortEventCards(root);
      initialiseEventFilters(root);
    });
  };

  initialiseEventGrids();

  document.addEventListener('shopify:section:load', (event) => {
    initialiseEventGrids(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
